var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(20%,18.039216%,12.54902%)",
      fillOpacity: 1
    },
    d: "M 19.996094 14.179688 C 21.042969 11.9375 20.074219 9.269531 17.832031 8.226562 C 15.589844 7.179688 12.921875 8.148438 11.875 10.390625 C 10.832031 12.632812 11.800781 15.300781 14.042969 16.34375 C 16.285156 17.390625 18.949219 16.421875 19.996094 14.179688 Z M 14.71875 14.332031 L 14.71875 10.238281 L 18.238281 12.289062 Z M 14.71875 14.332031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(20%,18.039216%,12.54902%)",
      fillOpacity: 1
    },
    d: "M 28.097656 20.609375 L 28.097656 3.96875 L 3.777344 3.96875 L 3.777344 20.609375 L 15.066406 20.609375 L 15.066406 27.007812 L 8.257812 27.007812 L 8.257812 28.289062 L 23.617188 28.289062 L 23.617188 27.007812 L 16.804688 27.007812 L 16.804688 20.609375 Z M 5.695312 18.6875 L 5.695312 5.886719 L 26.175781 5.886719 L 26.175781 18.6875 Z M 5.695312 18.6875 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedia);
export default __webpack_public_path__ + "static/media/media.1523ba1701cbf9d1d63e6f190c5472a3.svg";
export { ForwardRef as ReactComponent };